var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isData && _vm.complete == true)?_c('p',{staticClass:"noData"},[_vm._v(_vm._s(_vm.lang.infotext_1))]):_vm._e(),_vm._v(" "),(_vm.complete)?_c('canvas',{attrs:{"id":_vm.id}}):_vm._e(),_vm._v(" "),(!_vm.isData && _vm.complete == false)?_c('LoaderComponent'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0459044d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ChartComponent.vue
// module id = null
// module chunks = 